export default __webpack_public_path__ + "static/media/training-tour3.a176bb2e.svg";